import { connect } from 'react-redux';
import React, { useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import NavItem from '~/Components/Layout/ApplicationNavigation/NavItem';
import DropDown from '~/Components/Layout/ApplicationNavigation/DropDown';
import CalendarStyleSvg from '~/Components/Global/Assets/Svgs/CalendarStyle';
import Spinner from '~/Components/Global/Loading/Spinner';
import { eventFontSizeHelper } from '~/Components/Global/FontWrapper/FontWrapper';
import { setDropdownOpen } from '~/Redux/Modules/HandwritingUi';

import './Styles.scss';

const Styles = ({
  fonts,
  userOptions,
  updateFont,
  updateUserOptions,
  isFetching,
  dropdownOpen,
  setDropdownOpen,
}) => {
  const dropdownRef = useRef();
  useEffect(() => {
    const handleOpenStyleDropdown = () => {
      const dropdownElement = dropdownRef.current;

      if (dropdownElement) {
        dropdownElement.querySelector('.dropdown-toggle')?.click?.();

        if (dropdownOpen) {
          setTimeout(() => {
            dropdownElement.querySelector('.style-chooser-inner .dropdown-toggle')?.click?.();
            setDropdownOpen(false);
          }, 100);
        }
      }
    };

    window.addEventListener('native.openStyleDropdown', handleOpenStyleDropdown);
    return () => {
      window.removeEventListener('native.openStyleDropdown', handleOpenStyleDropdown);
    };
  }, [dropdownRef, dropdownOpen, setDropdownOpen]);

  return (
    <DropDown className="style-chooser" auth svg={CalendarStyleSvg} ref={dropdownRef}>
      <DropDown
        subMenu
        className="style-chooser-inner"
        auth
        label="CHOOSE HANDWRITING"
        ref={dropdownRef}
      >
        {fonts.map((font, index) => {
          return (
            <NavItem key={index} auth>
              <span onClick={() => updateFont(userOptions.id, font)}>
                <span
                  style={{ fontFamily: font.css, fontSize: eventFontSizeHelper(font.css) }}
                  className="menu-label"
                >
                  {font.css}
                </span>
                {userOptions && userOptions.font_id === font.id && (
                  <FontAwesome className="fa-check" name="check" />
                )}
              </span>
            </NavItem>
          );
        })}
        <hr />
        <NavItem
          key="use-in-events"
          className="use-in-events"
          onClick={() =>
            updateUserOptions({
              ...userOptions,
              use_font_for_events: !userOptions.use_font_for_events,
            })
          }
        >
          {isFetching ? (
            <Spinner />
          ) : (
            <FontAwesome
              className="use-font-in-events"
              name={`check-circle ${userOptions.use_font_for_events ? 'complete' : 'incomplete'}`}
            />
          )}
          <span>Use In Events</span>
        </NavItem>
      </DropDown>
      <NavItem label="CHOOSE COVER" path="/choose-cover-list" auth />
    </DropDown>
  );
};

Styles.propTypes = {
  fonts: propTypes.array,
  userOptions: propTypes.object,
  updateFont: propTypes.func,
  isFetching: propTypes.bool,
  updateUserOptions: propTypes.func,
  dropdownOpen: propTypes.bool,
  setDropdownOpen: propTypes.func,
};

const mapStateToProps = ({ HandwritingUi }) => ({
  dropdownOpen: HandwritingUi.dropdownOpen,
});

const mapDispatchToProps = dispatch => ({
  setDropdownOpen: open => dispatch(setDropdownOpen(open)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Styles);
